import { reportError } from './report-error';
import {closePopin, handlePopinAction, launchTooltip, translate} from "./functions";

export function initDuplicatePosEvents() {
    const container = document.getElementById('duplicatePosContainer');
    if (!container) {
        return;
    }

    const checkboxes = container.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
            const field = checkbox.closest('.field');
            const isInSub = checkbox.closest('.sub') !== null;

            if (!isInSub && field) {
                const sub = field.nextElementSibling;
                if (sub.classList.contains('sub')) {
                    const subCheckboxes = sub.querySelectorAll('input[type="checkbox"]');
                    subCheckboxes.forEach(function (subCheckbox) {
                        subCheckbox.checked = checkbox.checked;
                    });
                }
            }
        });
    });
    launchTooltip();
}

document.addEventListener('submit', function (e) {
    const container = document.getElementById('duplicatePosContainer');
    if (!container) {
        return;
    }
    const form = e.target;
    if (form.matches('#duplicatePos')) {
        e.preventDefault();
        const posSelect = document.getElementById('duplicate_pos_pos');
        const name = posSelect.options[posSelect.selectedIndex].text
        const confirm = window.confirm(translate('app.pos.duplicate.confirm', {'name': name}));
        if (!confirm) {
            return;
        }
        const loader = container.querySelector('.common-loader');
        const content = container.querySelector('.content');
        if (loader) loader.classList.remove('--hidden');
        if (content) content.classList.add('--hidden');

        const formData = new FormData(form);
        fetch(form.action, {
            method: form.method,
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    closePopin();
                    const flashText = document.querySelector('.js-flash-message-success .text');
                    const flashBox = document.querySelector('.js-flash-message-success');

                    if (flashText && flashBox) {
                        flashText.innerHTML = translate('app.pos.duplicate.success');
                        flashBox.classList.remove('--hidden');

                        setTimeout(function () {
                            flashBox.classList.add('--hidden');
                        }, 15000);
                    }
                } else {
                    if (content) {
                        container.outerHTML = data.html;
                        handlePopinAction()
                        initDuplicatePosEvents()
                    }
                }
            })
            .catch(error => {
                reportError('Duplication de PDV impossible', error);
                if (loader) loader.classList.add('--hidden');
                if (content) content.classList.remove('--hidden');
            });
    }
});